// 9fbef606107a605d69c0edbcd8029e5d
const HELPCENTER_CONSTANTS = {
  FETCH_SUBNAVIGATION_DATA: 'SET_SUBNAVIGATION_DATA',
  SET_SUBNAVIGATION_DATA: 'SET_SUBNAVIGATION_DATA',
  HELP_CENTER_PAGE_PREFIX: 'help-center/',
  HELP_CENTER_PAGE_PREFIX_NEW: 'help-center',
  HELP_CENTER_ROUTES: {
    HOME: 'faq',
  },
  get HELP_CENTER_HOME_PATH() {
    return `help-center/${this.HELP_CENTER_ROUTES.HOME}`;
  },
};
export default HELPCENTER_CONSTANTS;
